import Vue from 'vue'
import Vuex from 'vuex'
import getSystemInfo from '../utils/getSystemIno'
import toast from './module/toast'
import loading from './module/loading'
import userInfo from './module/userInfo'
import home from './module/home'
import activityInfo from './module/activityInfo'
import slideVerify from './module/slideVerify'
/**持久化仓库 */
// import createPersistedstate from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    toast,
    loading,
    userInfo,
    home,
    activityInfo,
    slideVerify
  },
  // plugins: [
  //   createPersistedstate({
  //     key: 'redRoute-store',
  //     paths: ['home']
  //   })
  // ],
  state: {
    systemInfo: {
      ios: false,
      pc: false,
      android: false,
      isWx: false,
      isPhoneX: false,
      isNfPlus: false
    },
    openAppOptions: {
      show: false,
      tips: ''
    }
  },
  getters: {
    systemInfo: state => state.systemInfo,
    openAppOptions: state => state.openAppOptions
  },
  mutations: {
    setSystemInfo (state, systemInfo) {
      state.systemInfo = systemInfo
    },
    showOpenApp (state, tips) {
      state.openAppOptions.tips = tips
      state.openAppOptions.show = true
    },
    closeOpenApp (state) {
      state.openAppOptions.show = false
    }
  },
  actions: {
    async getSystemInfo ({ commit }) {
      const systemInfo = await getSystemInfo()
      commit('setSystemInfo', systemInfo)
    }
  }
})
